<div class="citation p4 pb-5 p">
  <div class="modal-header header-container pl-6 pl-sm-9 pr-4 pt-4 pb-0">
    <h2 class="modal-title header mt-5 mb-0 pb-0" data-automation-id="citation-title">
      {{ isCitationMailingEnabled ? ('exportCitationModalTitle' | translate) : ('exportCitation' | translate) }}
    </h2>
    <button type="button" class="close" [attr.aria-label]="'closeDialog' | translate" (click)="onClose()" data-automation-id="citation-close-btn">
      <span aria-hidden="true" class="icon-close"></span>
    </button>
  </div>
  <div class="modal-body body px-6 px-sm-9 py-0 mt-5">
    <div class="form-group mb-0">
      <label class="edition-label" for="edition-select" data-automation-id="citation-edition-label" translate>editionTitle</label>
      <select class="custom-select select p-4 mb-0" id="edition-select" name="select" [formControl]="editionSelect"
        data-automation-id="citation-edition-select">
        <option *ngFor="let edition of editions; trackBy: trackById" [value]="edition.id"
          data-automation-id="citation-edition-option">
          {{ edition.editionInfo }}
        </option>
      </select>
    </div>
    <div *ngIf="isCitationMailingEnabled" class="form-group mt-7">
      <fieldset class="citation-options mb-0 pl-0">
        <legend translate>exportCitationFormatsLabel</legend>
        <div class="citation-options-holder">
          <input
            type="radio"
            id="option-mla"
            name="options"
            value="option-mla"
            (change)="onCitationStyleChange(citationStyle.MLA, citationStyleFullName.MLA)"
            checked
            data-automation-id="citation-option-mla"
          />
          <label for="option-mla" data-automation-id="citation-option-mla-label" translate>exportCitationFormatMla</label>
          <input
            type="radio"
            id="option-chicago"
            name="options"
            value="option-chicago"
            (change)="onCitationStyleChange(citationStyle.CHICAGO, citationStyleFullName.CHICAGO)"
            data-automation-id="citation-option-chicago"
          />
          <label for="option-chicago" data-automation-id="citation-option-chicago-label" translate>exportCitationFormatChicago</label>
        </div>
      </fieldset>
      <ng-template #citationContent>
        <div class="citation-text-holder" [innerHTML]="citationHtmlSanitized" aria-disabled="true"></div>
      </ng-template>
      <div *ngIf="isCitationLoading; else citationContent" aria-live="polite" role="status" class="d-flex justify-content-center my-10">
        <span class="spinner-border text-primary" data-automation-id="citation-spinner">
          <span class="sr-only" translate>Loading...</span>
        </span>
      </div>
    </div>
    <div *ngIf="isCitationMailingEnabled" class="form-group mt-4">
      <button
        type="button"
        class="btn btn-outline-dark action-button px-4 mb-2 mr-4 ml-0"
        [disabled]="isCitationLoading"
        (click)="onCopyCitation()"
        data-automation-id="citation-copy-button"
        translate
      >
        exportCitationCopyBtn
      </button>
      <button
        type="button"
        class="btn btn-outline-dark action-button px-4 mb-2 ml-0"
        [disabled]="isCitationLoading"
        (click)="toggleEmailSection()"
        data-automation-id="citation-toggle-email-button"
        translate
      >
        exportCitationEmailBtn
      </button>
    </div>
    <div *ngIf="isEmailSectionVisible && isCitationMailingEnabled" [formGroup]="form" class="form-group">
      <label for="emailInput" class="citation-email-label" translate>exportCitationEmailAddress</label>
      <div class="d-flex align-items-center">
        <input
          formControlName="email"
          type="email"
          class="form-control form-control-lg citation-email mr-2 mb-0"
          id="emailInput"
          [class.is-invalid]="emailControl.invalid && (emailControl.touched || emailControl.dirty)"
          placeholder="{{ 'emailSample' | translate }}"
          data-automation-id="citation-email-input"
        >
        <button
          type="submit"
          class="btn btn-dark action-button px-12"
          (click)="sendEmail()"
          [disabled]="!form || emailControl.invalid || isCitationLoading"
          data-automation-id="send-email-button"
          translate
        >
          shareItEmailEntitySendButton
        </button>
      </div>
      <div aria-atomic="true" aria-live="assertive" role="alert">
        <div class="invalid-feedback d-block" *ngIf="emailControl.invalid && emailControl.hasError('required') && (emailControl.touched || emailControl.dirty)"
             data-automation-id="invalid-email-required">{{ 'emailRequired' | translate }}</div>
        <div class="invalid-feedback d-block" *ngIf="emailControl.invalid && !emailControl.hasError('required') && (emailControl.touched || emailControl.dirty)"
             data-automation-id="invalid-email-format">{{ 'exportCitationEmailInvalid' | translate }}</div>
      </div>
    </div>
    <div *ngIf="isCopyMsgVisible" class="citation-message citation-message-success mt-5" data-automation-id="citation-copy-msg" translate>
      exportCitationCopyMsg
    </div>
    <div
      *ngIf="isEmailMsgVisible"
      class="citation-message mt-5"
      [ngClass]="{'citation-message-success': isEmailSuccess, 'citation-message-error': !isEmailSuccess}"
      data-automation-id="citation-email-msg"
    >
      {{ emailMessage }}
    </div>
  </div>
  <div class="modal-footer footer justify-content-between flex-wrap justify-content-sm-start px-6 px-sm-9 py-0 mt-6">
    <h3 *ngIf="isCitationMailingEnabled" class="footer-header" translate>exportCitationFooterHeader</h3>
    <div>
      <button type="button" class="btn btn-outline-dark action-button px-4 mb-2 mr-4 mr-sm-4 ml-0"
              data-automation-id="citation-RefWorks-button" (click)="onRefworks()">Refworks</button>
      <button type="button" class="btn btn-outline-dark action-button px-4 mb-2 mr-4 mr-sm-4 ml-0"
              data-automation-id="citation-Easybib-button" (click)="onEasybib()">Easybib</button>
      <button type="button" class="btn btn-outline-dark action-button px-4 mb-2 mr-4 mr-sm-4 ml-0"
              data-automation-id="citation-Zotero-button" [attr.aria-expanded]="!isZoteroCollapsed"
              [attr.aria-label]="(isZoteroCollapsed ? 'zoteroShowExportingInfo' : 'zoteroHideExportingInfo') | translate"
              (click)="onZotero()">Zotero</button>
      <button *ngIf="!isCitationMailingEnabled" [disabled]="!MENDELEY_URL" type="button"
              class="btn btn-outline-dark action-button px-4 mb-2 mr-4 mr-sm-4 ml-0"
              data-automation-id="citation-Mendeley-button" (click)="onMendeley()">Mendeley</button>
      <button type="button" class="btn btn-outline-dark action-button px-4 mb-2 mr-4 mr-sm-4 ml-0"
              data-automation-id="citation-RIS-button" (click)="onRISFile()">{{ 'risFile' | translate }}</button>
    </div>
  </div>
  <div class="px-6 px-sm-9 py-0 mt-6" *ngIf="!isZoteroCollapsed" data-automation-id="zotero-container" aria-live="assertive">
    <h3 class="zotero-collapse-title" data-automation-id="zotero-title">{{ 'zoteroCollapseTitle' | translate }}:</h3>
    <div class="card">
      <div class="card-body py-6 px-5">
        <ol class="mb-0">
          <li><button class="zotero-ris-file-button" data-automation-id="zotero-ris-file-link"
              (click)="onZoteroRISFile()">{{ 'risFileDownload' | translate }}</button></li>
          <li><a href="https://www.zotero.org/download" class="zotero-plugin-link" target="_blank" data-automation-id="zotero-plugin-link"
              (click)="onZoteroPlugin()">{{ 'zoteroPluginDownloadLink' | translate }}
            </a>&nbsp;<span data-automation-id="zotero-plugin-download-text">{{ 'zoteroPluginDownloadText' | translate }}</span>
          </li>
        </ol>
      </div>
    </div>
  </div>
</div>
